"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=permission.dto.js.map